// import { useCallback } from "react";
import { useShallow } from 'zustand/react/shallow'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
// import type { LiveGiftsAnimations } from "../../types/lives/animations";
import type { LiveBubbleMessage } from '../../../types/lives/live'

const LIVE_BUBBLE_MESSAGES = '/LIVE-BUBBLE-MESSAGES'

export const useUpdateToastBubbleMessage = () => {
  const liveId = useGlobalStore(
    useShallow((state) => {
      return state.liveId
    }),
  )
  const liveCountry = useGlobalStore(
    useShallow((state) => {
      return state.liveCountry
    }),
  )
  // const liveId = useGlobalStore(
  //   useShallow((state) => {
  //     return state.live;
  //   })
  // );

  const addBubbleMessageLive = useGlobalStore(
    useShallow((state) => {
      return state.addBubbleMessageLive
    }),
  )

  useSub<LiveBubbleMessage>({
    endpoint: `${LIVE_BUBBLE_MESSAGES}/all`,
    skip: !liveId,
    onData: addBubbleMessageLive,
  })

  useSub<LiveBubbleMessage>({
    endpoint: `${LIVE_BUBBLE_MESSAGES}/${liveCountry}`,
    skip: !liveCountry,
    onData: addBubbleMessageLive,
  })

  useSub<LiveBubbleMessage>({
    endpoint: `${LIVE_BUBBLE_MESSAGES}/${liveId}`,
    skip: !liveId,
    onData: addBubbleMessageLive,
  })
}
